var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolC2PaIcTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.72884V1.25384C20 0.128836 18.65 -0.421164 17.875 0.378836L10.875 7.35384C10.375 7.85384 10.375 8.62884 10.875 9.12884L17.85 16.1038C18.65 16.8788 20 16.3288 20 15.2038V10.7288C28.275 10.7288 35 17.4538 35 25.7288C35 27.7038 34.625 29.6288 33.9 31.3538C33.525 32.2538 33.8 33.2788 34.475 33.9538C35.75 35.2288 37.9 34.7788 38.575 33.1038C39.5 30.8288 40 28.3288 40 25.7288C40 14.6788 31.05 5.72884 20 5.72884ZM20 40.7288C11.725 40.7288 5 34.0038 5 25.7288C5 23.7538 5.375 21.8288 6.1 20.1038C6.475 19.2038 6.2 18.1788 5.525 17.5038C4.25 16.2288 2.1 16.6788 1.425 18.3538C0.5 20.6288 0 23.1288 0 25.7288C0 36.7788 8.95 45.7288 20 45.7288V50.2038C20 51.3288 21.35 51.8788 22.125 51.0788L29.1 44.1038C29.6 43.6038 29.6 42.8288 29.1 42.3288L22.125 35.3538C21.9488 35.1811 21.7253 35.0644 21.4829 35.0184C21.2404 34.9724 20.9897 34.9992 20.7625 35.0955C20.5352 35.1917 20.3416 35.3531 20.2059 35.5592C20.0702 35.7654 19.9986 36.007 20 36.2538V40.7288Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolC2PaIcTrust);
export default __webpack_public_path__ + "static/media/sol-c2pa-ic-trust.e9842f15e9c470c7f859928f8bab0acd.svg";
export { ForwardRef as ReactComponent };